import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import * as _ from "lodash";
import { plainToClass } from "class-transformer";
import { ITenantKVP } from "../models/shared/tenantKVP";
import { getTenantId } from "@/store/helper";
import { SecurityUserModel } from "../models/users/securityUsers";
import { UserProfileModel } from "../models/account/userProfile";
import { SecurityUserRoleVerificationModel } from "../models/users/securityUserRoleVerification";
import { IGetUserDetailForProfile } from "../models/account/responses/getUserDetailForProfile";
import { SecurityUserTwoFactorAuthConfigModel } from "../models/users/securityUserTwoFactorAuthConfigDTO";
import { VerifyTwoFactorAuthModel } from "../models/users/verifyTwoFactorAuthDTO";
import { TwoFactorAuthStatusModel } from "../models/users/twoFactorAuthDTO";
let SettingsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    let SettingsModule = class SettingsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.tenants = [];
            this.tenant = null;
            this.userProfile = new UserProfileModel();
            this.role = null;
            this.appMenus = [];
            this.userRights = [];
            this.userTimeZone = null;
            this.timeZones = [];
            this.userDateFormat = "";
            this.dateFormats = [];
            this.userRole = null;
            this.isTeamLead = false;
            this.IsUserHasOrganizationSettings = false;
            this.apiNode = "tenantuser";
            this.tenantFeatures = [];
            this.twoFactorAuthConfig = null;
            this.recoveryCodes = [];
            this.isTwoFactorAuthEnabled = false;
            this.twoFactorAuthStatus = null;
        }
        // googleConfiguration: GoogleCalendarConfigurationModel | null = null;
        // isGoogleCalendarSynced: boolean = false;
        async GetTenants() {
            let { data } = await service.get("user/tenants");
            if (data) {
                this.SetTenants(data.tenants);
            }
            return [];
        }
        async AssignSelectedTenant(tenant) {
            if (tenant) {
                localStorage.setItem("tenantId", tenant.id.toString());
                localStorage.setItem("tenantName", tenant.name);
            }
            else {
                // Something wrong here
                var tenantName = localStorage.getItem("tenantName");
                var tenantId = Guid.parse(localStorage.getItem("tenantId"));
                tenant = { id: tenantId, name: tenantName, isUserAssigned: true };
            }
            this.SetTenant(tenant);
        }
        async GetUserProfile() {
            var url = `${getTenantId()}/tenantuser/profile`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCurrentUserProfileImageUrl(data);
                return data;
            }
        }
        async IsAppUserTeamLead() {
            var url = `${getTenantId()}/security/isTeamLead`;
            let { data } = await service.get(url);
            this.SetTeamLead(data);
            return data;
        }
        /* User Portal Roles */
        async FindUserRole() {
            let { data } = await service.get("user/role");
            if (data) {
                this.SetRole(data.securityUserRoleVerification);
                return data.securityUserRoleVerification;
            }
        }
        async UpdateDateFormatAndTimeZone(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/userDateFormatAndTimeZone`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                this.SetCurrentUserDateFormat(data.securityUser);
                return data;
            }
        }
        async UploadTenantLogo(file) {
            var url = `${getTenantId()}/${this.apiNode}/tenant-logo`;
            let { data } = await service.post(url, file);
            if (data) {
                return data;
            }
        }
        async TwoFactorConfig() {
            var url = `${getTenantId()}/${this.apiNode}/2FA-config`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTwoFactorConfig(plainToClass(SecurityUserTwoFactorAuthConfigModel, data.twoFactorAuthConfig));
                return data;
            }
        }
        async VerifyTwoAuth(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/2FA-verify`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                this.SetEnableTwoFactorAuth(plainToClass(TwoFactorAuthStatusModel, data.twoFactorAuthResult.twoFactorAuthStatus));
                return data;
            }
        }
        async GettingRecoveryCodes() {
            var url = `${getTenantId()}/${this.apiNode}/2FA-recovery-codes`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRecoveryCodes(data.recoveryCodes);
                return data;
            }
        }
        async disableTwoFactorAuth(password) {
            var url = `${getTenantId()}/${this.apiNode}/2FA-disable`;
            let payload = new VerifyTwoFactorAuthModel();
            payload.passWord = password;
            let { data } = await service.post(url, payload);
            if (data) {
                this.SetdisableTwoFactorAuth();
                return data;
            }
        }
        async CheckTwoFactorAuthIsEnabled() {
            var url = `${getTenantId()}/${this.apiNode}/2FA-status`;
            let { data } = await service.get(url);
            if (data) {
                this.SetEnableTwoFactorAuth(plainToClass(TwoFactorAuthStatusModel, data.twoFactorAuthStatus));
                return data;
            }
        }
        SetdisableTwoFactorAuth() {
            this.twoFactorAuthStatus.isTwoFactorAuthEnabled = false;
            this.twoFactorAuthStatus.twoFactorAuthEnabledOnAsString = "";
        }
        // @Mutation
        // public SetCalendarIntegrationSyncedStatus() {
        //     this.isGoogleCalendarSynced = true;
        // }
        SetEnableTwoFactorAuth(twoFactorAuthStatusModel) {
            this.twoFactorAuthStatus = twoFactorAuthStatusModel;
        }
        SetRecoveryCodes(codes) {
            this.recoveryCodes = codes;
        }
        SetTwoFactorConfig(payLoad) {
            this.twoFactorAuthConfig = payLoad;
        }
        SetCurrentUserDateFormat(payLoad) {
            if (payLoad.timeZone) {
                this.userTimeZone = payLoad.timeZone;
            }
            if (payLoad.dateFormat) {
                this.userDateFormat = payLoad.dateFormat;
            }
        }
        SetRole(role) {
            //console.log('Role is being set');
            this.role = role;
        }
        SetTenants(tenants) {
            this.tenants = _.orderBy(tenants, [
                (o) => {
                    return o.name.trim().toLowerCase() || "";
                },
            ], ["asc"]);
        }
        SetTenant(tenant) {
            this.tenant = tenant;
        }
        IsUserHasOrganizationSettingsUpdated(isVerified) {
            this.IsUserHasOrganizationSettings = isVerified;
        }
        SetCurrentUserProfileImageUrl(data) {
            this.userProfile.profileImageUrl = data.profileImageUrl;
            this.userProfile.tenantLogoUrl = data.tenantLogoUrl;
            this.IsUserHasOrganizationSettings = data.isUserHasOrganizationSettings;
            this.appMenus = data.appMenus;
            this.userRights = data.userRights;
            this.timeZones = data.timeZones;
            this.userTimeZone = data.userTimeZone;
            this.userDateFormat = data.userDateFormat;
            this.dateFormats = data.dateFormats;
            this.timeZones = data.timeZones;
            this.userRole = data.role;
            this.tenantFeatures = data.tenantFeatures;
            // this.isGoogleCalendarSynced = data.isGoogleCalendarSynced;
        }
        async SetTeamLead(isTeamLead) {
            this.isTeamLead = isTeamLead;
        }
        get GetSelectedTenant() {
            return this.tenant;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], SettingsModule.prototype, "GetTenants", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ITenantKVP !== "undefined" && ITenantKVP) === "function" ? _b : Object]),
        __metadata("design:returntype", Promise)
    ], SettingsModule.prototype, "AssignSelectedTenant", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], SettingsModule.prototype, "GetUserProfile", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], SettingsModule.prototype, "IsAppUserTeamLead", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], SettingsModule.prototype, "FindUserRole", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof SecurityUserModel !== "undefined" && SecurityUserModel) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], SettingsModule.prototype, "UpdateDateFormatAndTimeZone", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof FormData !== "undefined" && FormData) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], SettingsModule.prototype, "UploadTenantLogo", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], SettingsModule.prototype, "TwoFactorConfig", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof VerifyTwoFactorAuthModel !== "undefined" && VerifyTwoFactorAuthModel) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], SettingsModule.prototype, "VerifyTwoAuth", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], SettingsModule.prototype, "GettingRecoveryCodes", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], SettingsModule.prototype, "disableTwoFactorAuth", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], SettingsModule.prototype, "CheckTwoFactorAuthIsEnabled", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetdisableTwoFactorAuth", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof TwoFactorAuthStatusModel !== "undefined" && TwoFactorAuthStatusModel) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetEnableTwoFactorAuth", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetRecoveryCodes", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof SecurityUserTwoFactorAuthConfigModel !== "undefined" && SecurityUserTwoFactorAuthConfigModel) === "function" ? _s : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetTwoFactorConfig", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetCurrentUserDateFormat", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_t = typeof SecurityUserRoleVerificationModel !== "undefined" && SecurityUserRoleVerificationModel) === "function" ? _t : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetRole", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetTenants", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_u = typeof ITenantKVP !== "undefined" && ITenantKVP) === "function" ? _u : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetTenant", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "IsUserHasOrganizationSettingsUpdated", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_v = typeof IGetUserDetailForProfile !== "undefined" && IGetUserDetailForProfile) === "function" ? _v : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetCurrentUserProfileImageUrl", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], SettingsModule.prototype, "SetTeamLead", null);
    SettingsModule = __decorate([
        Module({ dynamic: true, store: store, name: "settings", namespaced: true })
    ], SettingsModule);
    return SettingsModule;
})();
export const SettingModule = getModule(SettingsModule);
